import 'babel-polyfill'
import 'whatwg-fetch'
import {
  upperFirst,
  camelCase,
} from 'lodash'
import Vue from 'vue'
import VueAxios from 'vue-axios'
import Vuetify from 'vuetify'
import axios from 'axios'
import App from './App'
import router from './router'
import store from './store'
import config from '../config'

import JsnlogPlugin from './components/plugins/JsnlogPlugin'
import VueI18n from 'vue-i18n'
import localStorageManager from './localStorageManager'
import requestPoolManager from './requestPoolManager'
import VCalendar from 'v-calendar-ie11'
import VirtualCollection from 'vue-virtual-collection'
// import IntroJs from 'intro.js'

/*global process*/
let base = (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'aztest')? config.build.assetsPublicPath : config.dev.assetsPublicPath

axios.defaults.baseURL = base
Vue.config.productionTip = false

// Injects $jsnLog to Vue.prototype.
// Adds errorCaptured() mixin.
Vue.use(JsnlogPlugin, {
  'customLoggerName': 'EnviroData front-end',
  'useAjaxLog': true,
  'useConsoleLog': false,
  'ajaxLogLevel': 'ALL',
  'ajaxLogStoreInBufferLevel': 'ALL',
  'ajaxLogSendWithBufferLevel': 'FATAL',
  'ajaxLogBufferSize': 10,
  'ajaxLogSendTimeout': 10000,
  'ajaxLogUrl': '/jsnlog.logger',
  'consoleLogLevel': 'FATAL',
  'passThroughError': false,
})

Vue.use(VueAxios, axios)
Vue.use(Vuetify)
Vue.use(VueI18n)
//Vue.use(IntroJs)
Vue.use(VirtualCollection)

// v-calendar & v-date-picker components
Vue.use(VCalendar, {
  componentPrefix: 'vc',
})

router.beforeEach(async (to, from, next) => {
  // Verify access token or trigger a refresh
  let isAuthed = await store.dispatch('authenticate/checkAuth')
  let isAdmin = store.getters['authenticate/isSystemAdmin']
  //console.info('Checking for existing authentication.', { isAuthed, isAdmin })

  // Don't show login page if authenticated
  if (isAuthed && to.name == 'login') {    
    next({ name: 'home' })
  }
  else if(to.name == 'Office365AuthResponse') {
    next()
  }
  // If still not authenticated, redirect to login
  else if (!isAuthed && to.name != 'login') {    
    store.dispatch('app/setSnackbar', { text: 'Your session has expired, please log in again.', icon: 'warning', color: 'primary' }, { root: true })
    store.dispatch('authenticate/logOut')
    next({ name: 'login', query: { redirect: to.fullPath } })
  }
  
  // if (['login', '/logout'].)
  // If not admin, but is an admin page, don't allow them to view it
  // TODO: Use the meta property and also check for tenant administration
  else if (to.path.indexOf('/administration') >= 0 && !isAdmin) {
    next('/')
  } else {
    next()
  }
})

var isTokenRefreshing = false

axios.interceptors.request.use(async (config) => {
  // Ignore these urls
  if (['/token', '/arcGisToken', '/api/Account/LogOff'].includes(config.url)) return config
  if(config.url.indexOf('/api/Authenticated') == 0) return config
  if (!store.state.authenticate.hasAccessToken) return config

  if (store.state.authenticate.isAccessTokenExpired()) {
    if (!isTokenRefreshing) {
      isTokenRefreshing = true

      let isRefreshed = await store.dispatch('authenticate/refreshToken')
      isTokenRefreshing = false

      if (isRefreshed) {
        var token = localStorageManager.getItem('access_token')
        requestPoolManager.dispatchToken(token)
        requestPoolManager.requestPool = []
      } else {
        //console.info('Session expired')
        store.dispatch('app/setSnackbar', { text: 'Your session has expired, please log in again.', icon: 'warning', color: 'primary' }, { root: true })
        store.dispatch('authenticate/logOut')
        throw 'Session expired.'
      }
    }

    // retry
    requestPoolManager.addItem(token => {
      var authorizationHeader = 'Bearer ' + token
      config.headers['Authorization'] = authorizationHeader
      return config
    })
  }

  let authorizationHeader = 'Bearer ' + localStorageManager.getItem('access_token')
  config.headers['Authorization'] = authorizationHeader
  return config
})



axios.defaults.retry = 1
axios.defaults.retryDelay = 1000

axios.interceptors.response.use(
  function(response) {
    return response
  },
  async function(error) {
    try {
      let data = error && error.response && error.response.data || null
      // if data is Blob, get string
      if (data && typeof(data) == 'object') {
        data = await data.text()
      }
      // https://stackoverflow.com/questions/726334/asp-net-mvc-jsonresult-date-format
      let dateTimeStringParser = (k, v) => {
        if (typeof v === 'string') {
          var d = /\/Date\((-?\d+)\)\//gi.exec(v)
          v = d ? new Date(+d[1]) : v
        }
        return v
      }

      // if data is JSON parseable, parse, then set err message and data
      let parsedData = data && JSON.parse(data, dateTimeStringParser) || null

      if (parsedData) {
        error.response.data = parsedData.Data || parsedData
        error.message = parsedData.Message || error.message
      }
    } catch (e) {
      // dont modify error if data is not parseable
    }

    // Log left for developer discovery
    console.info('Intercepted axios error', error.response.data)

    throw error
  })

var isIE11 = () => {
  // https://stackoverflow.com/a/17907562/5937169
  return navigator.userAgent.indexOf('Trident') >= 0
}

if (isIE11) {
  // Bug #14314
  // https://stackoverflow.com/a/45835054/5937169
  axios.defaults.headers.common['Pragma'] = 'no-cache'
}

// var getBrowserLanguage = () => {
//   var lang = ''
//   if (navigator.appName == 'Netscape') {
//     lang = navigator.language
//   } else {
//     lang = navigator.userLanguage
//   }
//   return lang.substr(0, 2)
// }

// var getLocalLanguage = () => {
//   if(window.localStorage.language != undefined) {
//     return window.localStorage.language
//   } else {
//     return getBrowserLanguage()
//   }
// }

var languages = []
store.state.app.languages.forEach(element => {
  languages.push(element.local)
})

const i18n = new VueI18n({
  // locale: languages.indexOf(getLocalLanguage()) != -1 ? getLocalLanguage() : 'en',
  locale: 'en',
  messages: {
    en: require('../static/language/en'),
    //zh: require('../static/language/zh'),
  },
})

// Register generic components
// https://vuejs.org/v2/guide/components-registration.html
const requireComponent = require.context(
  // The relative path of the components folder
  '@/components/generic',
  // Whether or not to look in subfolders
  true,
  // The regular expression used to match base component filenames
  /[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  // Get component config
  const componentConfig = requireComponent(fileName)

  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      // Gets the file name regardless of folder depth
      fileName
      .split('/')
      .pop()
      .replace(/\.\w+$/, '')
    )
  )

  // console.log('register', componentName)
  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig
  )
})

new Vue({
  components: {
    App,
  },
  el: '#app',
  router,
  store,
  template: '<App/>',
  i18n,
  mounted: function() {
    this.$vuetify.theme.primary = '#333'
    this.$vuetify.theme.secondary = '#666'
    this.$vuetify.theme.tertiary = '#777'
    this.$vuetify.theme.accent = '#8c9eff'
    this.$vuetify.theme.navbar = '#333'
    this.$vuetify.theme.sidebar = '#424242'
    this.$vuetify.theme.success = '#529943'
    this.$vuetify.theme.info = '#0B82EA'
    // warning use default
    // this.$vuetify.theme.error = '#F93956'
    // darker shade of red
    this.$vuetify.theme.error = '#B9121B'
    this.$vuetify.theme.add = this.$vuetify.theme.success
    this.$vuetify.theme.delete = this.$vuetify.theme.error
    this.$vuetify.theme.white = '#fff'
  },
})
